var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',{attrs:{"dark":_vm.dark}},[_vm._v("mdi-flag")]),_c('v-btn',{attrs:{"dark":_vm.dark,"text":""},on:{"click":function($event){return _vm.set_language('hu')}}},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }